import { Dialog, DialogProps, useGraphqlDelete, useListGraphqlQuery, useTranslationRoute, useTranslations, useUrlParamsValueToString } from "@bsm/component"
import { TBankInformation } from "@bsm/graphql";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BANK_LIST_ID } from "../container/BankListContainer";

export const DeleteBankDialog = (props: TProps) => {

    const [
        OK,
        CANCEL,
    ] = useTranslations(i18n);

    const deleteMutation = useGraphqlDelete('bankInformation')
    const navigate = useNavigate();
    const tr = useTranslationRoute()
    const urlParams = useUrlParamsValueToString()
    const { invalidateQuery } = useListGraphqlQuery(BANK_LIST_ID);

    useEffect(() => {
        if (deleteMutation.isSuccess) {
            invalidateQuery()
            navigate(tr(`admin/students/viewer/bank?${urlParams}`))
        }
    }, [deleteMutation])

    return (
        <Dialog
            title={"Delete bank"}
            open={props.open}
            confirmation
            onClose={props.onClose}
            onCancel={props.onClose}
            onConfirm={() => deleteMutation.mutate({ ids: [props?.id] })}
            btnOk={{ label: OK, isSubmit: deleteMutation.isLoading }}
            btnCancel={{ label: CANCEL }}
        >
            Are you sure you want to delete this bank ?
        </Dialog>
    )
}

const i18n = [
    "std_confirm",
    "std_cancel",
]

type TProps = Partial<TBankInformation> & Partial<DialogProps> 